var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Dialog as BaseDialog, dialogClasses as baseDialogClasses, } from "@vividtheory/minerva-lab";
import { CloseOutline } from "@vividtheory/minerva-lab/icons";
import React, { useEffect, useState } from "react";
import { Box, IconButton, Stack, TopAppBar } from "../components";
import { mergeSx } from "../system";
export const dialogVariants = [
    "centered-medium",
    "centered-small",
    "full-screen",
    "centered-mid-small",
];
export const dialogClasses = Object.assign({ "centered-medium": "BigGeoDialog-centeredMedium", "centered-small": "BigGeoDialog-centeredSmall", "full-screen": "BigGeoDialog-fullScreen", "centered-mid-small": "BigGeoDialog-centeredMidSmall" }, baseDialogClasses);
export const Dialog = (_a) => {
    var { sx, variant = "centered-medium", title, disableCloseOnClickAway = false, disablePortal, onClose, hideTopAppBar = false, open: _open, children } = _a, props = __rest(_a, ["sx", "variant", "title", "disableCloseOnClickAway", "disablePortal", "onClose", "hideTopAppBar", "open", "children"]);
    const [open, setOpen] = useState(_open);
    useEffect(() => {
        setOpen(_open);
    }, [_open]);
    return (React.createElement(BaseDialog, Object.assign({ open: open, onOpenChange: (open) => {
            setOpen(open);
            !open && (onClose === null || onClose === void 0 ? void 0 : onClose());
        }, disableCloseOnClickAway: disableCloseOnClickAway, disablePortal: disablePortal, className: dialogClasses[variant], sx: mergeSx({
            [`&.${dialogClasses["centered-medium"]}`]: {
                borderStartEndRadius: (theme) => theme.radius.sm4,
                borderStartStartRadius: (theme) => theme.radius.sm4,
                backgroundColor: (theme) => theme.palette.background.main,
                display: "flex",
                flexDirection: "column",
                marginBottom: 0,
                height: "98%",
                width: "100%",
                overflow: "hidden",
            },
            [`&.${dialogClasses["centered-small"]}`]: {
                borderRadius: (theme) => theme.radius.sm4,
                backgroundColor: (theme) => theme.palette.background.main,
                overflow: "hidden",
                width: 100,
                maxWidth: (theme) => `calc(100% - ${theme.spacing(8)})`,
                maxHeight: 180,
                margin: "auto",
            },
            [`&.${dialogClasses["full-screen"]}`]: {
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100dvh",
                overflow: "auto",
                borderRadius: (theme) => theme.radius.none,
            },
            [`&.${dialogClasses["centered-mid-small"]}`]: {
                borderStartEndRadius: (theme) => theme.radius.sm4,
                borderStartStartRadius: (theme) => theme.radius.sm4,
                backgroundColor: (theme) => theme.palette.background.main,
                display: "flex",
                flexDirection: "column",
                marginBottom: 0,
                height: "70%",
                width: "100%",
                overflow: "hidden",
            },
            breakpoints: {
                md: {
                    [`&.${dialogClasses["centered-medium"]}`]: {
                        height: 120,
                        width: 120,
                        borderRadius: (theme) => theme.radius.sm4,
                        margin: "auto",
                    },
                    [`&.${dialogClasses["full-screen"]}`]: {
                        width: "100%",
                        height: "100%",
                        margin: "auto",
                    },
                    [`&.${dialogClasses["centered-mid-small"]}`]: {
                        height: 75,
                        width: 120,
                        borderRadius: (theme) => theme.radius.sm4,
                        margin: "auto",
                    },
                },
            },
        }, sx) }, props),
        !hideTopAppBar && (React.createElement(TopAppBar, { title: title, variant: "small", density: "dense", endNode: onClose ? (React.createElement(Stack, { alignSelf: "flex-start", flexDirection: "row", gap: 2 },
                React.createElement(IconButton, { onClick: () => {
                        setOpen(false);
                        onClose();
                    }, variant: "minimal", density: "none" },
                    React.createElement(CloseOutline, { size: "xs" })))) : undefined })),
        React.createElement(Box, { sx: {
                width: "100%",
                flexGrow: 1,
                overflow: "auto",
            } }, children)));
};
//# sourceMappingURL=Dialog.js.map